import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  InputGroup,
  CardImg
} from "reactstrap"
import { withTranslation } from "react-i18next"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Flatpickr from 'react-flatpickr'
import 'flatpickr/dist/themes/material_blue.css' // Flatpickr theme
import swal from "sweetalert"
import { useParams } from "react-router-dom"
import image from './banner2.png'




  const nationalities = [
    "Algerian", "American", "British", "Canadian", "Chinese", "Egyptian", "French",
    "German", "Indian", "Italian", "Japanese", "Moroccan", "Nigerian", "Russian",
    "Saudi", "South African", "Spanish", "Sudanese", "Syrian", "Tunisian", "Turkish",
    "UAE", "Ukrainian"
  ]
  

const dummyData = [
  {
    id: 1,
    nom: "Smith",
    prenom: "John",
    email: "john.smith@example.com",
    noPassport: "A1234567",
    expirationDate: new Date("2025-10-15"),
    nationality: "French",
    phoneNumber: "+33 6 12 34 56 78",
    hotelCity: "Paris",
    dateOfDepart: new Date("2024-08-01"),
    hotelLocation: "123 Rue de Rivoli",
    departCity: "New York",
    timeToStay: "5 days",
    startPrice: "800 USD",
    numberOfAdults: 2,
    numberOfChildren: 1,
    priceForAdult: "400 USD",
    priceForChild: "200 USD"
  },
  {
    id: 2,
    nom: "Johnson",
    prenom: "Emily",
    email: "emily.johnson@example.com",
    noPassport: "B9876543",
    expirationDate: new Date("2026-04-20"),
    nationality: "German",
    phoneNumber: "+49 176 1234 5678",
    hotelCity: "Berlin",
    dateOfDepart: new Date("2024-07-15"),
    hotelLocation: "456 Alexanderplatz",
    departCity: "London",
    timeToStay: "3 days",
    startPrice: "600 USD",
    numberOfAdults: 1,
    numberOfChildren: 0,
    priceForAdult: "600 USD",
    priceForChild: "0 USD"
  },
  {
    id: 3,
    nom: "Brown",
    prenom: "Michael",
    email: "michael.brown@example.com",
    noPassport: "C2468135",
    expirationDate: new Date("2025-12-31"),
    nationality: "Italian",
    phoneNumber: "+39 333 9876543",
    hotelCity: "Rome",
    dateOfDepart: new Date("2024-08-20"),
    hotelLocation: "789 Via del Corso",
    departCity: "Madrid",
    timeToStay: "7 days",
    startPrice: "1200 USD",
    numberOfAdults: 2,
    numberOfChildren: 2,
    priceForAdult: "600 USD",
    priceForChild: "300 USD"
  },
  {
    id: 4,
    nom: "Williams",
    prenom: "Sophia",
    email: "sophia.williams@example.com",
    noPassport: "D1357924",
    expirationDate: new Date("2025-09-10"),
    nationality: "Spanish",
    phoneNumber: "+34 612 345 678",
    hotelCity: "Barcelona",
    dateOfDepart: new Date("2024-07-25"),
    hotelLocation: "987 Rambla de Catalunya",
    departCity: "Paris",
    timeToStay: "4 days",
    startPrice: "900 USD",
    numberOfAdults: 1,
    numberOfChildren: 1,
    priceForAdult: "900 USD",
    priceForChild: "450 USD"
  },
  {
    id: 5,
    nom: "Miller",
    prenom: "David",
    email: "david.miller@example.com",
    noPassport: "E5678910",
    expirationDate: new Date("2026-03-15"),
    nationality: "British",
    phoneNumber: "+44 7700 123456",
    hotelCity: "London",
    dateOfDepart: new Date("2024-07-30"),
    hotelLocation: "234 Oxford Street",
    departCity: "Berlin",
    timeToStay: "6 days",
    startPrice: "1000 USD",
    numberOfAdults: 2,
    numberOfChildren: 0,
    priceForAdult: "500 USD",
    priceForChild: "0 USD"
  },
]

const BilletCheckout = ({ t }) => {
  const { id } = useParams()
  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    email: "",
    noPassport: "",
    wilaya: "",
    nationality: "",
    phoneNumber: "",
    hotelCity: "",
    dateOfDepart: "",
    hotelLocation: "",
    departCity: "",
    timeToStay: "",
    startPrice: "",
    numberOfAdults: 0,
    numberOfChildren: 0,
    priceForAdult: "0 USD",
    priceForChild: "0 USD"
  })

  useEffect(() => {
    const selectedData = dummyData.find(item => item.id === parseInt(id))
    if (selectedData) {
      setFormData({
        nom: selectedData.nom,
        prenom: selectedData.prenom,
        email: selectedData.email,
        noPassport: selectedData.noPassport,
        expirationDate: selectedData.wilaya,
        nationality: selectedData.nationality,
        phoneNumber: selectedData.phoneNumber,
        hotelCity: selectedData.hotelCity,
        dateOfDepart: selectedData.dateOfDepart.toLocaleDateString(),
        hotelLocation: selectedData.hotelLocation,
        departCity: selectedData.departCity,
        timeToStay: selectedData.timeToStay,
        startPrice: selectedData.startPrice,
        numberOfAdults: selectedData.numberOfAdults,
        numberOfChildren: selectedData.numberOfChildren,
        priceForAdult: selectedData.priceForAdult,
        priceForChild: selectedData.priceForChild
      })
    }
  }, [id])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData({
      ...formData,
      [name]: value,
    })
  }

  const handleDateChange = (date, fieldName) => {
    setFormData({
      ...formData,
      [fieldName]: date[0], // Flatpickr returns an array of selected dates
    })
  }

  // Calculate total price based on number of adults and children
  const totalPrice = formData.numberOfAdults * parseFloat(formData.priceForAdult) +
                    formData.numberOfChildren * parseFloat(formData.priceForChild)

  const handleConfirm = () => {
    swal("Request Confirmed!", "Request details: " + JSON.stringify(formData), "success")
    // Additional logic for handling confirmed request
  }

  const handleRefuse = () => {
    swal("Request Refused!", "Request details: " + JSON.stringify(formData), "error")
    // Additional logic for handling refused request
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title={t("Voyage")} breadcrumbItem={t(`Voyage/${id}`)} />
        <Row>
          <Col lg={5}>
            <Card>
              <CardBody>
                <CardTitle className="mb-4">{t("Information de l'utilisateur")}</CardTitle>
                
                <FormGroup row className="mb-3">
                  <Col>
                    <Label for="nom" sm={4}>
                      {t("Nom")}
                    </Label>
                    <Col sm={12}>
                      <Input
                        type="text"
                        id="nom"
                        name="nom"
                        value={formData.nom}
                        onChange={handleChange}
                        required
                        readOnly
                      />
                    </Col>
                    </Col>

                    <Col>
                    <Label for="prenom" sm={4}>
                      {t("Prénom")}
                    </Label>
                    <Col sm={12}>
                      <Input
                        type="text"
                        id="prenom"
                        name="prenom"
                        value={formData.prenom}
                        onChange={handleChange}
                        required
                        readOnly
                      />
                    </Col>
                    </Col>
                  </FormGroup>
                <FormGroup>
                  <Label for="email">{t("Email")}</Label>
                  <Input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="noPassport">{t("Numéro de passeport")}</Label>
                  <Input
                    type="text"
                    id="noPassport"
                    name="noPassport"
                    value={formData.noPassport}
                    onChange={handleChange}
                  />
                
                </FormGroup>

                <FormGroup>
                  <Label for="noPassport">{t("Date d'expiration")}</Label>
                  <Input
                    type="text"
                    id="noPassport"
                    name="noPassport"
                    value={formData.noPassport}
                    onChange={handleChange}
                  />
                
                </FormGroup>

                <FormGroup row className="mb-3">
                  <Col>
                      <Label for="wilaya" sm={6}>
                        {t("Nationality")}
                      </Label>
                      <Col sm={12}>
                        <Input
                          type="select"
                          id="nationality"
                          name="nationality"
                          value={formData.nationality}
                          onChange={handleChange}
                          required
                        >
                          <option value="" disabled>{t("Select Nationality")}</option>
                          {nationalities.map((nationality) => (
                            <option key={nationality} value={nationality}>
                              {nationality}
                            </option>
                          ))}
                        </Input>
                      </Col>
                    </Col>

                    <Col>
                    <Label for="phoneNumber" sm={6}>
                      {t("Numéro de téléphone")}
                    </Label>
                    <Col sm={12}>
                      <Input
                        type="text"
                        id="phoneNumber"
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                        required
                        readOnly
                      />
                    </Col>
                    </Col>
                  </FormGroup>
              </CardBody>
            </Card>
          </Col>

          <Col lg={7}>

          <Card>
            <CardImg
                top
                width="100%"
                src={image}
                alt="Card image cap"
              />
             
            </Card>
            <Card>
              <CardBody>
                <CardTitle className="h4 mb-4">{t("Résumé des prix")}</CardTitle>
                <Row>
                  <Col md={8}>
                    <FormGroup className="mb-3">
                      <Label>{t("Alger - Paris Simple (1) Adult")}</Label>
                      <Row>
                        <Col className="text-right">{formData.numberOfAdults * parseFloat(formData.priceForAdult)} USD</Col>
                        <Col>{formData.numberOfAdults} x {formData.priceForAdult}</Col>
                      </Row>
                    </FormGroup>
                    <FormGroup className="mb-2">
                      <Label>{t("Baggage Per (1) 5-7 KG")}</Label>
                      <Row>
                        <Col className="text-right">{formData.numberOfChildren * parseFloat(formData.priceForChild)} USD</Col>
                        <Col>{formData.numberOfChildren} x {formData.priceForChild}</Col>
                      </Row>
                    </FormGroup>
                    
                  </Col>
                </Row>
                <hr className="my-2" />
                <Row>
                  <Col md={8}>
                    <FormGroup className="mb-3">
                      <Label>{t("Total")}</Label>
                      <Row>
                        <Col>{t("Total")} :</Col>
                        <Col className="text-right font-weight-bold">{totalPrice.toFixed(2)} USD</Col>
                      </Row>
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default withTranslation()(BilletCheckout)
